// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from image-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function ImageFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2ZM9.541 5.122a.41.41 0 0 0-.638.069L7.365 7.564l1.789 2.456a.931.931 0 0 1 .076.98h3.353l.08-.008a.432.432 0 0 0 .266-.658L9.596 5.19ZM6.19 6.818a.41.41 0 0 0-.605.068l-2.5 3.428-.04.067c-.135.275.056.619.373.619h5l.076-.007a.432.432 0 0 0 .257-.679l-2.5-3.428Z"
      />
    </svg>
  );
}
